import getAccountErrorMessage from "@saleor/utils/errors/account";

export function usePasswordValidation(initialForm) {
  const { confirmPassword, newPassword } = initialForm;

  const newPasswordMessage = () => {
    if (newPassword === "") {
      return "This field should not be empty.";
    } else if (newPassword.length < 8) {
      return "This password is too short. It must contain at least 8 characters.";
    }
    return null;
  };

  const confirmPasswordMessage = () => {
    if (confirmPassword !== newPassword) {
      return "Confirm Password should be equal to New Password.";
    }

    return null;
  };

  return {
    confirmPassword: confirmPasswordMessage(),
    newPassword: newPasswordMessage()
  };
}

export const checkError = (key, formErrors, validationError, intl) => {
  const message = formErrors[key]
    ? formErrors[key].message
    : getAccountErrorMessage(formErrors[key], intl);
  return {
    hasError: !!formErrors[key] || !!validationError[key],
    message: formErrors[key] ? message : validationError[key]
  };
};

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
